import { useMemo, useCallback } from 'react';
import { ShippingRestrictionResponseDto } from '@tiendanube/common';
import { ShippingMethodOption } from '../../../hooks/useShippingMethodsOptions';

interface UseDisabledShippingMethodsParams {
  restrictions: ShippingRestrictionResponseDto[];
  currentRestrictionId?: string;
}

interface UseDisabledShippingMethodsReturn {
  isMethodDisabled: (method: ShippingMethodOption) => boolean;
}

export function useDisabledShippingMethods({
  restrictions,
  currentRestrictionId,
}: UseDisabledShippingMethodsParams): UseDisabledShippingMethodsReturn {
  const disabledMethodCodes = useMemo(() => {
    const relevantRestrictions = currentRestrictionId
      ? restrictions.filter((r) => r.id !== currentRestrictionId)
      : restrictions;

    const usedMethods = new Set<string>();

    for (const restriction of relevantRestrictions) {
      for (const code of restriction.selectedShippingMethods ?? []) {
        usedMethods.add(code);
      }
    }

    return usedMethods;
  }, [restrictions, currentRestrictionId]);

  const isMethodDisabled = useCallback(
    (method: ShippingMethodOption): boolean =>
      disabledMethodCodes.has(method.code),
    [disabledMethodCodes],
  );

  return {
    isMethodDisabled,
  };
}

export default useDisabledShippingMethods;
